const BruneiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111035)">
      <path
        d="M20.0005 39.998C31.0446 39.998 39.9976 31.0451 39.9976 20.001C39.9976 8.9569 31.0446 0.00390625 20.0005 0.00390625C8.95641 0.00390625 0.00341797 8.9569 0.00341797 20.001C0.00341797 31.0451 8.95641 39.998 20.0005 39.998Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.68217 10.002C1.77957 11.5651 1.11378 13.1994 0.67041 14.864L34.1132 34.1723C35.3331 32.956 36.4156 31.5621 37.318 29.999L2.68217 10.002Z"
        fill="black"
      />
      <path
        d="M29.9984 2.68201C21.997 -1.93755 12.1311 -0.397903 5.88672 5.82817L39.3295 25.1363C41.5993 16.6157 37.9997 7.30164 29.9984 2.68201Z"
        fill="#FFDA44"
      />
      <path
        d="M10.0015 37.3177C18.0027 41.9373 27.8688 40.3977 34.1131 34.1717L0.670265 14.8633C-1.59939 23.3842 2.00006 32.6982 10.0015 37.3177Z"
        fill="#FFDA44"
      />
      <path
        d="M25.6513 17.827C25.6513 20.9481 23.1211 23.4784 20 23.4784C16.8788 23.4784 14.3486 20.9482 14.3486 17.827C14.3486 16.8539 14.5946 15.9381 15.0279 15.1387C13.8016 16.3928 13.0444 18.1079 13.0444 20.0006C13.0444 23.842 16.1585 26.9561 20 26.9561C23.8415 26.9561 26.9555 23.8421 26.9555 20.0006C26.9555 18.1079 26.1985 16.3928 24.972 15.1387C25.4053 15.9383 25.6513 16.8539 25.6513 17.827Z"
        fill="#D80027"
      />
      <path d="M18.6958 11.3047H21.3041V24.3463H18.6958V11.3047Z" fill="#D80027" />
      <path
        d="M24.3467 13.9131H15.6523C15.6523 14.5133 16.1752 14.9999 16.7754 14.9999H16.7392C16.7392 15.6002 17.2258 16.0867 17.826 16.0867C17.826 16.687 18.3126 17.1735 18.9128 17.1735H21.0864C21.6866 17.1735 22.1732 16.687 22.1732 16.0867C22.7734 16.0867 23.26 15.6002 23.26 14.9999H23.2238C23.8238 14.9998 24.3467 14.5134 24.3467 13.9131Z"
        fill="#D80027"
      />
      <path d="M13.9141 25.2168H26.0862V27.8251H13.9141V25.2168Z" fill="#D80027" />
      <path d="M22.6084 26.0869H27.825V28.6953H22.6084V26.0869Z" fill="#D80027" />
      <path d="M12.1753 26.0869H17.3919V28.6953H12.1753V26.0869Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111035">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BruneiSvg;
